import { DateRangePicker } from "@/components/shared/date-range-picker";
import { SearchableSelect } from "@/components/shared/searchable-select";
import { Input } from "@/components/ui/input";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";

import type { FilterOption } from "./types";

export interface DateRangeFilter {
  from: string;
  to: string;
  onChange: (from: string, to: string) => void;
}

interface Props {
  searchPlaceholder: string;
  showSearch: boolean;
  query: string;
  onQueryChange?: (value: string) => void;
  filters?: FilterOption[];
  activeFilters: Record<string, string>;
  onFilterChange?: (key: string, value: string) => void;
  dateRange?: DateRangeFilter;
}

export function DataTableToolbar({
  searchPlaceholder,
  showSearch,
  query,
  onQueryChange,
  filters,
  activeFilters,
  onFilterChange,
  dateRange,
}: Props) {
  if (!showSearch && !filters?.length && !dateRange) return null;

  return (
    <div className="flex flex-col gap-2 sm:flex-row sm:flex-wrap">
      {showSearch && (
        <Input
          placeholder={searchPlaceholder}
          value={query}
          onChange={(e) => onQueryChange?.(e.target.value)}
          className="h-9 w-full sm:w-64"
        />
      )}
      {filters?.map((f) =>
        f.searchable ? (
          <div key={f.key} className="h-9 w-full sm:w-48">
            <SearchableSelect
              value={activeFilters[f.key] ?? ""}
              onChange={(v) => onFilterChange?.(f.key, v)}
              options={[{ value: "", label: `Semua ${f.label}` }, ...f.options]}
              placeholder={f.label}
            />
          </div>
        ) : (
          <Select
            key={f.key}
            value={activeFilters[f.key] ?? "all"}
            onValueChange={(v) => onFilterChange?.(f.key, v)}
          >
            <SelectTrigger className="h-9 w-full sm:w-44">
              <SelectValue placeholder={f.label} />
            </SelectTrigger>
            <SelectContent>
              <SelectItem value="all">Semua {f.label}</SelectItem>
              {f.options.map((o) => (
                <SelectItem key={o.value} value={o.value}>
                  {o.label}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
        ),
      )}
      {dateRange && (
        <DateRangePicker
          from={dateRange.from}
          to={dateRange.to}
          onChange={dateRange.onChange}
          className="w-full sm:w-auto"
        />
      )}
    </div>
  );
}
